<template>
    <div>
        <!-- Button trigger modal -->
        <button :id="tipousuario+'succesCreationBtn'" type="button" class="btn btn-primary invisible" data-bs-toggle="modal"
            :data-bs-target="'#succesCreation'+tipousuario">
        </button>
        <transition name="modal-fade">
            <!-- Modal -->
            <div class="modal fade" :id="'succesCreation'+tipousuario" tabindex="-1" aria-labelledby="succesCreationLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header bg-white">
                            <h5 class="modal-title" id="succesCreationLabel"><strong>Usuario creado correctamente</strong></h5>
                            <button type="button" class="btn btn-close bg-utel-v2-secondary active" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="col-12 mb-3">
                                <label class="form-label">Nombre</label>
                                <input type="text" class="form-control sin-borde" disabled :value="usuario.firstname">
                            </div>
                            <div class="col-12 mb-3">
                                <label class="form-label">Apellido</label>
                                <input type="text" class="form-control sin-borde" disabled :value="usuario.lastname">
                            </div>
                            <div class="col-12 mb-3" v-if="tipousuario=='student'">
                                <label class="form-label">Cargo</label>
                                <input type="text" class="form-control sin-borde" disabled :value="usuario.position">
                            </div>
                            <div class="col-12 mb-3" v-if="tipousuario=='student'">
                                <label class="form-label">Área</label>
                                <input type="text" class="form-control sin-borde" disabled :value="usuario.area">
                            </div>
                            <div class="col-12 mb-3" v-if="tipousuario=='student'">
                                <label class="form-label">Nivel</label>
                                <input type="text" class="form-control sin-borde" disabled :value="usuario.level">
                            </div>
                            <div class="col-12 mb-3" v-if="tipousuario=='admin'">
                                <label class="form-label">Rol</label>
                                <input type="text" class="form-control sin-borde" disabled :value="usuario.role">
                            </div>
                            <div class="col-12 mb-3">
                                <label class="form-label">Email</label>
                                <input type="text" class="form-control sin-borde" disabled :value="usuario.email">
                            </div>
                            <div class="col-12 mb-3" v-if="tipousuario=='student'">
                                <label class="form-label">Teléfono</label>
                                <input type="text" class="form-control sin-borde" disabled :value="usuario.cellphone">
                            </div>
                        </div>
                        <div class="modal-footer justify-content-center" style="font-size: 12px;">
                            <button type="button" class="btn btn-utel text-light" data-bs-dismiss="modal">Aceptar</button>
                        </div>
                    </div>
                </div>
            </div> 
        </transition>
    </div>
</template>

<script>
    export default {
        props: ["usuario", "tipousuario"],
        data() {
            return {
                
            }
        }
    }
</script>